import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Text,
} from "@chakra-ui/react";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface FormValues {
    otp: string;
}

export default function SignupOTP() {
    const { t } = useTranslation();
    const methods = useFormContext<FormValues>();

    return (
        <FormControl isInvalid={!!methods.formState.errors.otp}>
            <FormLabel color="#707070" fontSize="18px">
                {t("One time password")}
            </FormLabel>
            <Text fontSize="14px" color="#707070" mb="8px">
                {t("We have sent a code to your email. Please check and enter the code below.")}
            </Text>
            <Controller
                name="otp"
                control={methods.control}
                rules={{
                    required: "OTP is required!",
                    pattern: {
                        value: /^\d+$/,
                        message: "Invalid OTP format",
                    },
                }}
                render={({ field }) => (
                    <Input
                        {...field}
                        type="text"
                        placeholder="Enter OTP code"
                        border="1px solid #bababc"
                        p="22px 14px"
                    />
                )}
            />
            <FormErrorMessage>
                {methods.formState.errors?.otp?.message}
            </FormErrorMessage>
        </FormControl>
    );
}
